<template>
<div>
  <risk-assessment-std-doc/>
</div>
</template>

<script>
import RiskAssessmentStdDoc from '@/views/project/risk/assessment/RiskAssessmentStdDoc'
export default {
  name: 'ContentRiskAssessmentStddoc',
  components: {RiskAssessmentStdDoc},
}
</script>

<style scoped>

</style>
